export default __webpack_public_path__ + "static/media/logo-hki.f95f6e21.png";